export default __webpack_public_path__ + "static/media/demo-2.efa14d42.png";